import { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import Icons from '../../svgs/icons';
const RejectPopup = ({
  open,
  onClose,
  onSubmit,
  isLoadingUpdate,
  title,
  message,
  setReason,
  reason
}) => {
  const cancelButtonRef = useRef(null);
  const [isError, setIsError] = useState(false);
  return (
    <Transition.Root appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => {
          onClose();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full  justify-center p-4 text-center items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[702px]">
                <div className="border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-white px-4 pt-5 pb-4 sm:px-14 sm:py-[32px]">
                  <div className="sm:flex sm:items-start">
                    {/* <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <QuestionMarkCircleIcon
                        className="h-6 w-6 text-shoorah-secondary"
                        aria-hidden="true"
                      />
                    </div> */}
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                      <Dialog.Title
                        as="h3"
                        className="text-[32px] font-medium leading-9 dark:text-white text-shoorah-lightBlack text-center mb-[13px]"
                      >
                        {title}
                      </Dialog.Title>
                      <p className="mb-6 text-lg leading-5 dark:text-white text-shoorah-lightBlack text-center">
                        {message}
                      </p>
                      <div className="">
                        {/* <label htmlFor="reason" className="mb-2">
                          Reason
                        </label> */}
                        <div className="relative">
                          <div className="absolute left-8 top-4 opacity-50">
                            <Icons.textIcon />
                          </div>
                          <textarea
                            name="reason"
                            id="reason"
                            placeholder="Enter reason here..."
                            className="border-[1.5px] border-shoorah-borderGray dark:border-transparent mt-2 block pl-16 pt-4 pr-4 text-sm w-full h-[240px] dark:text-white rounded-xl bg-white dark:bg-shoorah-darkBgColor outline-none text-gray-500"
                            onChange={(e) => {
                              if (e.target.value?.length < 250) {
                                setReason(e.target.value);
                              } else {
                                e.target.value = e.target.value?.slice(0, 250);
                                setReason(e.target.value);
                              }
                            }}
                            value={reason}
                          ></textarea>
                          <div className="absolute bottom-4 right-4 text-xs leading-5 opacity-50 text-shoorah-lightBlack">
                            *250 Character limit
                          </div>
                        </div>
                        {reason.trim() == '' && isError && (
                          <div className="text-red-500 text-xs font-medium leading-5 text-center mt-[12px]">
                            * Text box cannot be empty
                          </div>
                        )}
                        <div className="text-center">
                          <button
                            className="btn-primary w-[194px] mt-[16px]"
                            disabled={isLoadingUpdate}
                            onClick={(e) => {
                              if (reason.trim() === '') {
                                setIsError(true);
                              } else {
                                onSubmit(reason);
                                setIsError(false);
                              }
                            }}
                          >
                            {isLoadingUpdate ? 'Loading...' : 'Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
export default RejectPopup;
